import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, segments) => {
  
    const router = inject(Router);
    const tokenReal = localStorage.getItem('access_token');
    
    if (!tokenReal) {
        console.warn('[AuthGuard] No se detectó token de autenticación. Redirigiendo a /login...');
        router.navigate(['/login']);
        return false;
    }

    return true;
  
};